export default async function onKlaviyoNewsletterFormSubmit(options: {
  email: string;
  firstName: string;
  klaviyoPublicApiKey: string;
  klaviyoNewsletterListId: string;
  klaviyoNewsletterSourceId: string;
}): Promise<boolean> {
  const response = await fetch(
    `https://a.klaviyo.com/client/subscriptions?company_id=${options.klaviyoPublicApiKey}`,
    {
      method: 'POST',
      headers: { revision: '2024-05-15', 'content-type': 'application/json' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: options.klaviyoNewsletterSourceId || '',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: options.email,
                  first_name: options.firstName,
                  locale: navigator.language || '',
                },
              },
            },
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: options.klaviyoNewsletterListId,
              },
            },
          },
        },
      }),
    },
  );

  return response.ok;
}
